import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const TableHeader = props => {
  const {
    title,
    url,
    updateList,
    isFetching,
    hideAddButton,
    hideUpdateButton
  } = props;
  return (
    <div className="row">
      <div className="col-sm-12">
        <h2 className="d-inline">
          {title}
          {!hideUpdateButton && (
            <button
              type="button"
              title="Atualizar Listagem"
              className="btn btn-info ml-2 mb-2"
              onClick={() => updateList()}
              disabled={isFetching}
            >
              <i className="fa fa-sync"></i>
            </button>
          )}
        </h2>
        {!hideAddButton && (
          <Link to={url}>
            <button
              type="button"
              title="Adicionar"
              className="btn btn-success mb-2 float-right"
            >
              <i className="fa fa-plus"></i>
            </button>
          </Link>
        )}
      </div>
    </div>
  );
};

TableHeader.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  updateList: PropTypes.func,
  isFetching: PropTypes.bool,
  hideAddButton: PropTypes.bool,
  hideUpdateButton: PropTypes.bool
};

export default TableHeader;
